import { render } from "./Customers.vue?vue&type=template&id=d17d13f6&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=d17d13f6&lang=scss&scoped=true"

import exportComponent from "D:\\local_sites\\svn_sandra\\outside_sales_system\\apps\\sales_visits_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d17d13f6"]])

export default __exports__